import React from "react";
import MessageItem from "./Items/MessageItem";
import EmailItem from "./Items/EmailItem";
import CallItem from "./Items/CallItem";
import CommentItem from "./Items/CommentItem";
import NotificationItem from "./Items/NotificationItem";
import Collection from "./Items/Collection";
import ChangeItem from "./Items/ChangeItem";
import SelfCareItem from "./Items/SelfCareItem";
import SpecInstanceRef from "./Items/SpecInstanceRef";
import Highlight from "react-highlighter";
import { HistoryItemTypes } from "../../../../constants";
import i18next from "util/i18n";

export const convertHistoryFilters = data => {
    return data.map(item => ({
        label: item.label,
        value: item.code,
        active: item.default,
    }));
};

export const getMarkdownProps = value => {
    return {
        source: value,
        unwrapDisallowed: true, // still place content of disallowedTypes
        disallowedTypes: ["paragraph"], // remove all paragraphs <p></p>render
    };
};

export const getHistoryItemComponent = type => {
    const componentMap = {
        [HistoryItemTypes.CHANGE]: ChangeItem,
        [HistoryItemTypes.EMAIL]: EmailItem,
        [HistoryItemTypes.MESSAGE]: MessageItem,
        [HistoryItemTypes.NOTIFICATION]: NotificationItem,
        [HistoryItemTypes.COLLECTION]: Collection,
        [HistoryItemTypes.COMMENT]: CommentItem,
        [HistoryItemTypes.CALL]: CallItem,
        [HistoryItemTypes.PRECRM]: CallItem,
        [HistoryItemTypes.SELF_CARE]: SelfCareItem,
        [HistoryItemTypes.SPEC_INSTANCE_REF]: SpecInstanceRef,
    };

    return componentMap[type] || null;
};

export const highlight = (text, query) => (
    <Highlight search={query} matchClass="highlight" matchElement={"span"}>
        {text}
    </Highlight>
);

export const getAuthorName = (items, checkCollection) => {
    const allowedTypes = [
        HistoryItemTypes.CHANGE,
        HistoryItemTypes.COMMENT,
        HistoryItemTypes.MESSAGE
    ];

    if (checkCollection) {
        allowedTypes.push(HistoryItemTypes.COLLECTION);
    }
    
    const historyItem = items.find(item => allowedTypes.includes(item.type));
    return (historyItem && historyItem.item.author.name) || i18next.t("systemMessage");
};
